module.exports = __webpack_public_path__ + "img/SZ.6141f93d.png";